<div class="ui-g-12" style="min-height: 30px">
    <a class="dimension-picker" (click)="showDialog()"
        >{{ this.label }}: <strong *ngIf="this.dimension && this.dimension.data">{{ this.dimension.data.name }}</strong></a
    >
    <button
        *ngIf="this.dimension"
        class="p-button-info"
        style="margin-left: 6px"
        pButton
        (click)="clear()"
        icon="ui-icon-clear"
    ></button>
    <button
        *ngIf="!this.dimension"
        class="p-button-info"
        pButton
        (click)="showDialog()"
        icon="ui-icon-touch-app"
    ></button>
</div>

<p-dialog
    header="Pick Account"
    *ngIf="dimensionPickerVisible"
    [(visible)]="dimensionPickerVisible"
    [style]="{ width: '70%' }"
    appendTo="body"
    class="clear-ui"
>
    <div class="ui-g">
        <div class="ui-g-12">
            <tree-table
                [inputTreeNodes]="accountsForTable"
                [treeColumns]="tableColumns"
                selectionMode="single"
                [(selected)]="this.selected"
            ></tree-table>
        </div>
    </div>
    <div class="ui-g">
        <div class="ui-g-12">
            <button
                label="OK"
                pButton
                icon="ui-icon-check"
                (click)="okClick()"
                style="margin-right: 0.5em"
            ></button>
            <button
                label="Cancel"
                pButton
                icon="ui-icon-cancel"
                (click)="dimensionPickerVisible = false"
            ></button>
        </div>
    </div>
</p-dialog>
